const emailSuccessData = {
    en: {
        title: "Confirm your e-mail – it’s torture-free we promise.",
        subttl: "We will not torture you, but if you don't confirm your login in the e-mail we just sent to you, you are forbidden to join the royal fleet ...",
        subttl1: "You’re just one step away – so get over to that inbox and confirm the message.",
        subttl2: "Thanks and here’s to a plain sailing voyage together."
    },
    ka: {
        title: "დაადასტურეთ თქვენი ელფოსტა – გპირდებით, წამების გარეშეა.",
        subttl: "არ გაწამებთ, მაგრამ თუ ახლახან გამოგზავნილ ელფოსტაში რეგისტრაციას არ დაადასტურებთ, აკრძალული გექნებათ სამეფო ფლოტის წევრობა ...",
        subttl1: "მხოლოდ ერთი ნაბიჯი გაყვთ დარჩენილი – გადადით ელფოსტის ყუთში და დაადასტურეთ შეტყობინება.",
        subttl2: "გმადლობთ და გილოცავთ საერთო მოგზაურობას."
    },
};

const emailConfirmData = {
    en: {
        title: "We have it!",
        subttl: "Your email has been successfully stored in our hold and is coming with us on our expeditions.",
        subttl1: "Just so you know - we've got a shipwrecked scribe on board, so he'll write you a scroll as soon as something new happens.",
        subttl2: "Look forward!",
        buttonName: "Continue",
    },
    ka: {
        title: "მივიღეთ!",
        subttl: "თქვენი ელფოსტა წარმატებით ინახება ჩვენს ტვირთში და ჩვენთან ერთად მოგზაურობს ექსპედიციებში.",
        subttl1: "რომ იცოდეთ – გემბანზე გვყავს გემის მსხვრევას გადარჩენილი მწერალი, ამიტომ გაგიწერთ გრაგნილს, როგორც კი მოხდება რამე ახალი.",
        subttl2: "ელოდეთ!",
        buttonName: "გაგრძელება",
    },
};

export {
    emailSuccessData, emailConfirmData
};